import React from 'react';
import { withRouter } from 'react-router-dom';
import Navigation from '../Navigation';
import logo from '../../images/up-logo.svg';

const Header = () => (
	<header>
		<Navigation />
		<div className="banner">
			<div>
				<h1><img className="logo" src={logo} alt="Unbridled Prayers" /></h1>
			</div>
		</div>
	</header>
);

export default withRouter(Header);